import { create } from 'zustand';

export const useModalStore = create((set) => ({
  isOpen: false,
  type: null,
  data: {},

  onOpen: (type, data = {}) =>
    set(() => ({
      isOpen: true,
      type,
      data,
    })),

  onClose: () =>
    set(() => ({
      isOpen: false,
      type: null,
      data: {},
    })),

  onDataUpdate: (data) =>
    set((state) => ({
      data: { ...state.data, ...data },
    })),
}));
